import React, {
  FC,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import styles from "./Receivable.module.scss";
import { Box, Button, Tab, InputBase, Chip } from "@mui/material";
import threedots from "../../../assets/images/threedots.svg";
import { PaymentService } from "../../../Services/payment.service";
import { GetAllDto } from "../../../Shared/dto/get-all-dto";
import { useLoading } from "../../../Shared/services/loading-context";
import { DisplayDate } from "../../../Shared/services/date-format";
import { useSnackbar } from "notistack";
import moment from "moment";
import { DisplayAmount } from "../../../Shared/services/amount-format";

interface ReceivableProps { contactId?: number }

const Receivable: FC<any> = forwardRef((props: any, ref: any) => {
  const [receivableList, setReceivableList] = useState<any[]>([]);
  const { loading, setLoading } = useLoading();
  const { enqueueSnackbar } = useSnackbar();

  /**
   * Receivable Get Api
   */
  const getData = async (searchQuery?: string) => {
    const getAllDto = new GetAllDto("", props.contactId);
    if (searchQuery) {
      getAllDto.searchQuery = searchQuery;
    }
    setLoading(true);
    const response = await PaymentService.getReceivableData(getAllDto);
    setLoading(false);
    if (response.success) {
      const data = response.data;
      for (let i = 0; i < data.length; i++) {
        const dueDate = moment(data[i].dueDate);
        const today = moment.now();
        if (dueDate.isSameOrBefore(today)) {
          data[i].isExpired = true;
        }
      }
      setReceivableList(data);
    } else enqueueSnackbar(response.message ?? "Internal server error", { variant: "error" });
  };

  useImperativeHandle(ref, () => ({
    receivableListingData: getData,
  }));

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      {receivableList.map((currElem) => {
        return (
          <Box key={currElem.id} className="payment-box">
            <div className="payment-serial-block-no">
              <span>{currElem.invoiceNumber}</span> <br />
              <span>{currElem.blockNumber}</span>
            </div>

            <div className="payment-textalign">
              <span className="person-name">{currElem.contactName}</span> <br />
              <span className="payment-contactno">{currElem.mobileNo}</span>
            </div>

            <div className="payment-textalign">
              <span className="payment-date">
                {DisplayDate(currElem.invoiceDate)}
              </span>
              <br />
              {/* <span className="payment-due-date">20/12/2020</span> */}
              <span className="payment-due-date">{currElem.isExpired}</span>
            </div>

            <div className="d-flex">
              <div className="d-grid">
                <span className="amount amount-first">
                  {DisplayAmount(currElem.totalAmount)}
                </span>
                <span className="amount amount-second">
                  {DisplayAmount(currElem.paidAmount ?? 0)}
                </span>
              </div>
            </div>
          </Box>
        );
      })}
    </div>
  );
});

Receivable.displayName = "Receivable";

export default Receivable;
